"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 9a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1zm0 6.014a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.276 3.959c.773-1.315 2.675-1.315 3.448 0l8.251 14.027C22.76 19.32 21.798 21 20.252 21H3.748c-1.546 0-2.508-1.68-1.723-3.014L10.276 3.96zM12 4.973 3.748 19h16.504L12 4.973z"
  }));
};
WarningIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "wrapper": "ErrorBoundary__wrapper__3jfxq",
  "error": "ErrorBoundary__error__lgOXD",
  "heading": "ErrorBoundary__heading__2hoha",
  "hint": "ErrorBoundary__hint__PM80S",
  "refresh-button": "ErrorBoundary__refresh-button__2rJaZ",
  "refreshButton": "ErrorBoundary__refresh-button__2rJaZ",
  "icon": "ErrorBoundary__icon__2ob_t"
}; 
require('./ErrorBoundary.css');
var ErrorBoundary = /*#__PURE__*/function (_Component) {
  function ErrorBoundary() {
    var _this;
    (0, _classCallCheck2.default)(this, ErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ErrorBoundary, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      hasError: false
    });
    (0, _defineProperty2.default)(_this, "reloadPage", function () {
      return global.location.reload();
    });
    return _this;
  }
  (0, _inherits2.default)(ErrorBoundary, _Component);
  return (0, _createClass2.default)(ErrorBoundary, [{
    key: "render",
    value: function render() {
      if (!this.state.hasError) {
        return this.props.children;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: styles.wrapper
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: styles.error
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        className: styles.icon,
        size: 60
      }, /*#__PURE__*/_react.default.createElement(WarningIcon, null)), /*#__PURE__*/_react.default.createElement("p", {
        className: styles.heading
      }, "Something went wrong."), /*#__PURE__*/_react.default.createElement("p", null, this.props.message), /*#__PURE__*/_react.default.createElement("p", {
        className: styles.hint
      }, "Try", ' ', /*#__PURE__*/_react.default.createElement("button", {
        className: styles.refreshButton,
        onClick: this.reloadPage,
        type: "button"
      }, "refreshing"), ' ', "your browser.")));
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(ErrorBoundary, "propTypes", {
  message: _propTypes.default.string.isRequired,
  children: _propTypes.default.node
});
var _default = exports.default = ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map